export default __webpack_public_path__ + "e8f94c119c51495ac2e091da11aa04f6.png";